module.exports = function() {
  return new Worker(__webpack_public_path__ + "e55cf58457b23a233eac.worker.js");
};